import React from 'react';
import './HeaderSignUp.css';

export default function HeaderSignUp() {
  return (
    <div className="header-signup-mob">
        <h1 className="heading-signup-mob">Feedback</h1>
        <p className="content-signup-mob">Add your products and give us your valuable feedback</p>
    </div>
  )
}
